import * as Dtos from "../../../../dtos/Tmd.dtos";
import classNames from "classnames";
import * as React from "react";
import { FieldAction } from "react-redux-form";
import {
    FontAwesomeIcon,
    FontAwesomeIcons,
} from "../../../../constants/fontAwesomeIcons";
import ValidationMessage from "../../validation/ValidationMessage";
import { Tooltip } from "src/components/Tooltip";
import {
    CheckboxFormInput,
    DatePickerFormInputFabric,
    NumberFormInput,
    SelectFormInput,
    TextAreaFormInput,
    TextFormInput,
} from "../../inputs";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

import "./PrimitiveFormInput.scss";

export interface IPrimitiveFormInputProps {
    item?: Dtos.ItemComponentPrimitive;
    textValue?: string;
    intValue?: number;
    bitValue?: boolean;
    numberValue?: number;
    dateValue?: any;
    feedbackIcon?: IconDefinition;
    className?: string;
    label?: string;
    name: string;
    id: string;
    onChange?: (field: string, value: any) => void;
    validationFailures?: Dtos.ResponseError[];
    onFocus?: () => FieldAction;
    disabled?: boolean;
    focused?: boolean;
    valid?: boolean;
    invalid?: boolean;
    modified?: boolean;
    hasSoftError?: boolean;
    hasHardError?: boolean;
    isRequired?: boolean;
    instructions?: string;
    isNaAllowed?: boolean;
    isNa?: boolean;
    hideLabels?: boolean;
    compact?: boolean;
}

class PrimitiveFormInput extends React.PureComponent<
    IPrimitiveFormInputProps,
    any
> {
    renderPrimitive(
        labelLeft: boolean,
        item: Dtos.ItemComponentPrimitive,
        content: any
    ) {
        let result: JSX.Element;
        const { name, validationFailures } = this.props;

        const hasValidationFailures =
            validationFailures && validationFailures.length > 0;

        if (this.props.hideLabels) {
            result = (
                <div className="row">
                    <div className="col-12">
                        <div className={"d-flex"}>
                            <div className={"flex-grow-1"}>{content}</div>
                            {this.props.isNaAllowed && (
                                <div className="p-2">
                                    <CheckboxFormInput
                                        name={name + "_isNa"}
                                        id={name + "isNa"}
                                        value={this.props.isNa}
                                        onChange={(v, o) => {
                                            if (this.props.onChange) {
                                                this.props.onChange("isNa", v);
                                            }
                                            return null;
                                        }}
                                        additionalContent={""}
                                        disabled={false}
                                        hideLabel={false}
                                        label={"N/A"}
                                    />
                                </div>
                            )}
                            {this.props.item.instructions != undefined &&
                                this.props.item.instructions != "" && (
                                    <Tooltip content={this.props.item.instructions}>
                                        <div>
                                            <p className="p-2 text-center">
                                                <FontAwesomeIcon
                                                    icon={
                                                        FontAwesomeIcons.Solid
                                                            .INFO_CIRCLE
                                                    }
                                                    fixedWidth
                                                />
                                            </p>
                                        </div>
                                    </Tooltip>
                                )}
                        </div>
                    </div>
                </div>
            );
        }
        else if (labelLeft) {
            result = (
                <div className="row">
                    <div className="col-5">
                        {item.label != "" && (
                            <label
                                className={classNames("mt-2 mb-1", {
                                    "is-invalid": hasValidationFailures,
                                })}
                            >
                                {this.props.isRequired && (
                                    <>
                                        <FontAwesomeIcon
                                            icon={
                                                FontAwesomeIcons.Solid.ASTERISK
                                            }
                                            fixedWidth
                                        />
                                        <span>&nbsp;</span>
                                    </>
                                )}
                                {item.label}
                            </label>
                        )}
                    </div>
                    <div className="col-7">
                        <div className={"d-flex"}>
                            <div className={"flex-grow-1"}>{content}</div>
                            {this.props.isNaAllowed && (
                                <div className="p-2">
                                    <CheckboxFormInput
                                        name={name + "_isNa"}
                                        id={name + "isNa"}
                                        value={this.props.isNa}
                                        onChange={(v, o) => {
                                            if (this.props.onChange) {
                                                this.props.onChange("isNa", v);
                                            }
                                            return null;
                                        }}
                                        additionalContent={""}
                                        disabled={false}
                                        hideLabel={false}
                                        label={"N/A"}
                                    />
                                </div>
                            )}
                            {this.props.item.instructions != undefined &&
                                this.props.item.instructions != "" && (
                                    <Tooltip content={this.props.item.instructions}>
                                        <div>
                                            <p className="p-2 text-center">
                                                <FontAwesomeIcon
                                                    icon={
                                                        FontAwesomeIcons.Solid
                                                            .INFO_CIRCLE
                                                    }
                                                    fixedWidth
                                                />
                                            </p>
                                        </div>
                                    </Tooltip>
                                )}
                        </div>
                    </div>
                </div>
            );
        }
        else {
            result = (
                <div className="row">
                    <div className="col-12">
                        {item.label != "" && (
                            <label
                                className={classNames("mt-2 mb-1", {
                                    "is-invalid": hasValidationFailures,
                                })}
                            >
                                {this.props.isRequired && (
                                    <>
                                        <FontAwesomeIcon
                                            icon={
                                                FontAwesomeIcons.Solid.ASTERISK
                                            }
                                            fixedWidth
                                        />
                                        <span>&nbsp;</span>
                                    </>
                                )}
                                {item.label}
                            </label>
                        )}
                    </div>
                    <div className="col-12">
                        <div className={"d-flex"}>
                            <div className={"flex-grow-1"}>{content}</div>
                            {this.props.isNaAllowed && (
                                <div className="p-2">
                                    <CheckboxFormInput
                                        name={name + "_isNa"}
                                        id={name + "isNa"}
                                        value={this.props.isNa}
                                        onChange={(v, o) => {
                                            if (this.props.onChange) {
                                                this.props.onChange("isNa", v);
                                            }
                                            return null;
                                        }}
                                        additionalContent={""}
                                        disabled={false}
                                        hideLabel={false}
                                        label={"N/A"}
                                    />
                                </div>
                            )}
                            {this.props.instructions != undefined &&
                                this.props.instructions != "" && (
                                    <Tooltip content={this.props.instructions}>
                                        <div>
                                            <p className="p-2 text-center">
                                                <FontAwesomeIcon
                                                    icon={
                                                        FontAwesomeIcons.Solid
                                                            .INFO_CIRCLE
                                                    }
                                                    fixedWidth
                                                />
                                            </p>
                                        </div>
                                    </Tooltip>
                                )}
                        </div>
                    </div>
                </div>
            );
        }

        return result;
    }

    render() {
        const {
            className,
            item,
            textValue,
            intValue,
            bitValue,
            numberValue,
            dateValue,
            disabled,
            id,
            invalid,
            name,
            feedbackIcon,
            hasSoftError,
            hasHardError,
            validationFailures,
        } = this.props;

        const hasValidationFailures =
            validationFailures && validationFailures.length > 0;

        let labelLeft = true;
        let primitive: JSX.Element;

        switch (item.itemPrimitive) {
            case Dtos.ItemPrimitive.Label:
                primitive = (
                    <label className={classNames("mt-2 mb-1")}>
                        {item.label}
                    </label>
                );
                break;
            case Dtos.ItemPrimitive.Text:
                primitive = this.renderPrimitive(
                    labelLeft,
                    item,
                    <TextFormInput
                        name={name ? name : "TextFormInput-" + item.id}
                        id={id ? id : "TextFormInput-" + item.id}
                        value={textValue}
                        disabled={disabled}
                        className={classNames("form-control", {
                            "is-invalid": hasValidationFailures,
                            "is-modified": this.props.modified,
                        })}
                        onChange={(v, o) => {
                            if (this.props.onChange) {
                                this.props.onChange("textValue", v);
                            }
                            return null;
                        }}
                        placeholder={"Enter text..."}
                        mapProps={{}}
                    />
                );
                break;
            case Dtos.ItemPrimitive.Comments:
                primitive = this.props.compact
                    ? this.renderPrimitive(
                          labelLeft,
                          item,
                          <TextFormInput
                              name={name ? name : "TextFormInput-" + item.id}
                              id={id ? id : "TextFormInput-" + item.id}
                              value={textValue}
                              disabled={disabled}
                              className={classNames("form-control", {
                                  "is-invalid": hasValidationFailures,
                                  "is-modified": this.props.modified,
                              })}
                              onChange={(v, o) => {
                                  if (this.props.onChange) {
                                      this.props.onChange("textValue", v);
                                  }
                                  return null;
                              }}
                              placeholder={"Enter text..."}
                              mapProps={{}}
                          />
                      )
                    : this.renderPrimitive(
                          false,
                          item,
                          <TextAreaFormInput
                              name={
                                  name ? name : "TextAreaFormInput-" + item.id
                              }
                              id={id ? id : "TextAreaFormInput-" + item.id}
                              value={textValue}
                              disabled={disabled}
                              className={classNames("form-control", {
                                  "is-invalid": hasValidationFailures,
                                  "is-modified": this.props.modified,
                              })}
                              onChange={(v, o) => {
                                  if (this.props.onChange) {
                                      this.props.onChange("textValue", v);
                                  }
                                  return null;
                              }}
                              placeholder={"Enter text..."}
                              mapProps={{}}
                          />
                      );
                break;
            case Dtos.ItemPrimitive.Date:
                primitive = this.renderPrimitive(
                    labelLeft,
                    item,
                    <DatePickerFormInputFabric
                        name={
                            name ? name : "DatePickerFormInputFabric-" + item.id
                        }
                        className={classNames("form-control", {
                            "is-invalid": hasValidationFailures,
                        })}
                        id={id ? id : "DatePickerFormInputFabric-" + item.id}
                        value={dateValue}
                        disabled={disabled}
                        modified={this.props.modified}
                        onChange={(v, o) => {
                            if (this.props.onChange) {
                                this.props.onChange("dateValue", v);
                            }
                            return null;
                        }}
                    />
                );
                break;
            case Dtos.ItemPrimitive.Checkbox:
                if (labelLeft) {
                    primitive = (
                        <>
                            <CheckboxFormInput
                                name={
                                    name ? name : "CheckboxFormInput-" + item.id
                                }
                                disabled={disabled}
                                id={id ? id : "CheckboxFormInput-" + item.id}
                                value={bitValue}
                                onChange={(v, o) => {
                                    if (this.props.onChange) {
                                        this.props.onChange("bitValue", v);
                                    }
                                    return null;
                                }}
                                additionalContent={"test"}
                                hideLabel={false}
                                label={item.label}
                            />
                        </>
                    );
                }
                else {
                    primitive = (
                        <>
                            <CheckboxFormInput
                                name={
                                    name ? name : "CheckboxFormInput-" + item.id
                                }
                                disabled={disabled}
                                id={id ? id : "CheckboxFormInput-" + item.id}
                                value={bitValue}
                                onChange={(v, o) => {
                                    if (this.props.onChange) {
                                        this.props.onChange("bitValue", v);
                                    }
                                    return null;
                                }}
                                additionalContent={"test"}
                                hideLabel={false}
                                label={item.label}
                            />
                        </>
                    );
                }
                break;
            case Dtos.ItemPrimitive.Documents:
                primitive = (
                    <>
                        {item.label != "" && <label>{item.label}</label>}
                        <p
                            style={{
                                border: "1px dotted #888",
                                textAlign: "center",
                                padding: "10px",
                            }}
                        >
                            Multiple file upload grid
                        </p>
                    </>
                );
                break;
            case Dtos.ItemPrimitive.Numeric:
                primitive = this.renderPrimitive(
                    labelLeft,
                    item,
                    <NumberFormInput
                        name={name ? name : "NumberFormInput-" + item.id}
                        id={id ? id : "NumberFormInput-" + item.id}
                        value={numberValue}
                        disabled={disabled}
                        modified={this.props.modified}
                        onChange={(v, o) => {
                            if (this.props.onChange) {
                                this.props.onChange("numberValue", v);
                            }
                            return null;
                        }}
                    />
                );
                break;
            case Dtos.ItemPrimitive.Select:
                let options: any[] = [];
                if (item.itemComponentPrimitiveOptions) {
                    item.itemComponentPrimitiveOptions
                        .filter((f) => f.active)
                        .sort((a, b) => {
                            if (a.rank == b.rank) {
                                if (a.value < b.value) {
                                    return -1;
                                }
                                if (a.value > b.value) {
                                    return 1;
                                }
                                return 0;
                            } else {
                                return a.rank - b.rank;
                            }
                        })
                        .forEach((option) => {
                            options.push({
                                value: option.id,
                                label: option.value,
                            });
                        });
                }
                primitive = this.renderPrimitive(
                    labelLeft,
                    item,
                    <SelectFormInput
                        name={name ? name : "SelectFormInput-" + item.id}
                        className={classNames({
                            "is-invalid": hasValidationFailures,
                        })}
                        id={id ? id : "SelectFormInput-" + item.id}
                        disabled={disabled}
                        loading={false}
                        multi={false}
                        options={options}
                        clearable={true}
                        backspaceRemoves={true}
                        value={intValue}
                        onChange={(v, o) => {
                            if (this.props.onChange) {
                                this.props.onChange("intValue", v);
                            }
                            return null;
                        }}
                    />
                );
                break;
        }

        const hardFeedback =
            hasHardError && !disabled ? (
                <span
                    className={classNames(
                        "form-control-feedback block pr-2 is-invalid"
                    )}
                >
                    <FontAwesomeIcon
                        icon={
                            feedbackIcon
                                ? feedbackIcon
                                : FontAwesomeIcons.Solid.EXCLAMATION_CIRCLE
                        }
                        fixedWidth
                    />
                </span>
            ) : null;

        const feedback =
            invalid && !disabled && !hasHardError ? (
                <span className={classNames("form-control-feedback pr-2")}>
                    <FontAwesomeIcon
                        icon={
                            feedbackIcon
                                ? feedbackIcon
                                : FontAwesomeIcons.Solid.EXCLAMATION_CIRCLE
                        }
                        fixedWidth
                    />
                </span>
            ) : null;

        const softFeedback =
            hasSoftError && !disabled && !invalid ? (
                <span
                    className={classNames("form-control-feedback warning pr-2")}
                >
                    <FontAwesomeIcon
                        icon={
                            feedbackIcon
                                ? feedbackIcon
                                : FontAwesomeIcons.Solid.EXCLAMATION_TRIANGLE
                        }
                        fixedWidth
                    />
                </span>
            ) : null;

        const rowClass = this.props.compact
            ? "row no-gutters"
            : "row primitive-form-input no-gutters";
        const minHeight = this.props.compact ? "0px" : "40px";

        return (
            <div className="x-container-fluid">
                <div className={rowClass} style={{ minHeight: minHeight }}>
                    <div className={classNames("col-sm")}>
                        {primitive}
                        {invalid && !disabled && (
                            <>
                                {hardFeedback}
                                {softFeedback}
                            </>
                        )}
                        {feedback}
                        {hasValidationFailures ? (
                            <ValidationMessage className="validation-messages min-registration-validation-message-width">
                                {validationFailures &&
                                validationFailures.length > 0
                                    ? validationFailures.map(
                                          (failure, index) => {
                                              return (
                                                  <span
                                                      className="validation-message mb-2 mt-2"
                                                      key={
                                                          failure.fieldName +
                                                          "-failure-" +
                                                          index
                                                      }
                                                  >
                                                      {failure.message}
                                                  </span>
                                              );
                                              //return <span className="validation-message mb-2 mt-2" key={failure.fieldName + "-failure-" + index}>
                                              //    {failure.errorCode + ": " + failure.message}
                                              //</span>
                                          }
                                      )
                                    : null}
                            </ValidationMessage>
                        ) : null}
                    </div>
                </div>
            </div>
        );
    }
}

export default PrimitiveFormInput;
